 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		55: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		55: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"8eaa01260065b83f71183df2f75edd08d298df36","2":"component---src-templates-settings-js","3":"styles","4":"c9f4d727c200a4e1d9657da73522f0d55f96c697","5":"c533c783f2cded44a940301d7165223924f9410e","6":"db4891ff2bc78b1e7872c63ae6d86707e8758d49","7":"a304dd10bdf71c6e929c0064692f02c6f6c0dc3d","8":"ff98e52a269341e0f85e19c6b6f6538c7ac18897","9":"34df4d6e4cbc1ded59c5ac0b9789b4c810f80491","10":"badea5949fe611d9760bdbd4acda4643d28610e2","13":"component---src-templates-about-us-page-js","14":"component---src-templates-asset-management-page-js","15":"component---src-templates-careers-page-js","16":"component---src-templates-contact-page-js","17":"component---src-templates-custom-homes-page-js","18":"component---src-templates-footer-js","19":"component---src-templates-header-js","20":"component---src-templates-index-page-js","21":"component---src-templates-jp-about-us-page-jp-js","22":"component---src-templates-jp-asset-management-page-jp-js","23":"component---src-templates-jp-careers-page-jp-js","24":"component---src-templates-jp-contact-page-jp-js","25":"component---src-templates-jp-custom-homes-page-jp-js","26":"component---src-templates-jp-index-page-jp-js","27":"component---src-templates-jp-news-page-jp-js","28":"component---src-templates-jp-news-post-jp-js","29":"component---src-templates-jp-portfolio-page-jp-js","30":"component---src-templates-jp-privacy-page-jp-js","31":"component---src-templates-jp-project-management-page-jp-js","32":"component---src-templates-jp-property-listing-jp-js","33":"component---src-templates-jp-terms-page-jp-js","34":"component---src-templates-news-page-js","35":"component---src-templates-news-post-js","36":"component---src-templates-portfolio-order-js","37":"component---src-templates-portfolio-page-js","38":"component---src-templates-privacy-page-js","39":"component---src-templates-project-management-page-js","40":"component---src-templates-property-listing-js","41":"component---src-templates-terms-page-js","42":"component---src-templates-testimonials-page-js","43":"component---src-templates-zhhans-about-us-page-zhhans-js","44":"component---src-templates-zhhans-asset-management-page-zhhans-js","45":"component---src-templates-zhhans-careers-page-zhhans-js","46":"component---src-templates-zhhans-contact-page-zhhans-js","47":"component---src-templates-zhhans-custom-homes-page-zhhans-js","48":"component---src-templates-zhhans-index-page-zhhans-js","49":"component---src-templates-zhhans-news-page-zhhans-js","50":"component---src-templates-zhhans-privacy-page-zhhans-js","51":"component---src-templates-zhhans-project-management-page-zhhans-js","52":"component---src-templates-zhhans-property-listing-zhhans-js","53":"component---src-templates-zhhans-terms-page-zhhans-js"}[chunkId]||chunkId) + "-" + {"0":"6b27b16fa8809916c508","1":"fd75ef732bd7253ad6fa","2":"d3982a6a7ba119aad543","3":"dd3841a4888192e20843","4":"054cb9ae3fcaa33f2851","5":"a5dd173d9226d1af607e","6":"c30e0c919163c78178c3","7":"20ad93e94b4e5e5bf7df","8":"75793242109a03c1a27f","9":"414e6c40052eb407f72f","10":"65301151437e90732103","13":"5dc4b088f1d2aad4a1b4","14":"8c44e197bb3279cc785d","15":"a727dfb13f6f43881c45","16":"75a65965c9a52a89c073","17":"d08142c1f4c7384ca768","18":"577f37d45322d03eba98","19":"4eb43a26e4a0d2ac767d","20":"826d60cd90e82e3a9938","21":"9f37d7521895389bbfa6","22":"229cb0b2754d9f09f7bd","23":"97d1c7b257aa14d6bf69","24":"240866cfe5337972d448","25":"5233e778b2c9fee68ecc","26":"5d9cde4f431e39c722f6","27":"b1df52767b2834e815a8","28":"6a038ee596556390d7bc","29":"49b7dacedd5ee39453dc","30":"19f04a0066a75450f7f2","31":"209d6ab9abc439ad4731","32":"5c636741dd1c851a437a","33":"de4cc9e53d97242f04c3","34":"2dca8a43d5b0b3e26e06","35":"fd2253dc7470366573df","36":"e335ddd70e60a4733c99","37":"0cbbbe259c6b697a67b6","38":"6f1f87ed58183cf8bb21","39":"10cb3dcd1a69ab360d89","40":"525c2bcf98b4cda02c95","41":"9508a659ef170dde3197","42":"a5dc55ad43a4fd6101c0","43":"7af74423f1e5b83f690a","44":"3f06fb1dd3951a0f0ab6","45":"d5d65e8264286e338325","46":"bb9d4505eb2e5caea748","47":"fd7e6f14363ba840481f","48":"2b5636989d8b543e25f2","49":"cbc9fc4cfcf2d69606e1","50":"077e0e952590f8442fd8","51":"364430d99469e647b1fa","52":"a0e30b062c9bdcba7b0d","53":"0e96525104203dab4f5a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"8eaa01260065b83f71183df2f75edd08d298df36","2":"component---src-templates-settings-js","3":"styles","4":"c9f4d727c200a4e1d9657da73522f0d55f96c697","5":"c533c783f2cded44a940301d7165223924f9410e","6":"db4891ff2bc78b1e7872c63ae6d86707e8758d49","7":"a304dd10bdf71c6e929c0064692f02c6f6c0dc3d","8":"ff98e52a269341e0f85e19c6b6f6538c7ac18897","9":"34df4d6e4cbc1ded59c5ac0b9789b4c810f80491","10":"badea5949fe611d9760bdbd4acda4643d28610e2","13":"component---src-templates-about-us-page-js","14":"component---src-templates-asset-management-page-js","15":"component---src-templates-careers-page-js","16":"component---src-templates-contact-page-js","17":"component---src-templates-custom-homes-page-js","18":"component---src-templates-footer-js","19":"component---src-templates-header-js","20":"component---src-templates-index-page-js","21":"component---src-templates-jp-about-us-page-jp-js","22":"component---src-templates-jp-asset-management-page-jp-js","23":"component---src-templates-jp-careers-page-jp-js","24":"component---src-templates-jp-contact-page-jp-js","25":"component---src-templates-jp-custom-homes-page-jp-js","26":"component---src-templates-jp-index-page-jp-js","27":"component---src-templates-jp-news-page-jp-js","28":"component---src-templates-jp-news-post-jp-js","29":"component---src-templates-jp-portfolio-page-jp-js","30":"component---src-templates-jp-privacy-page-jp-js","31":"component---src-templates-jp-project-management-page-jp-js","32":"component---src-templates-jp-property-listing-jp-js","33":"component---src-templates-jp-terms-page-jp-js","34":"component---src-templates-news-page-js","35":"component---src-templates-news-post-js","36":"component---src-templates-portfolio-order-js","37":"component---src-templates-portfolio-page-js","38":"component---src-templates-privacy-page-js","39":"component---src-templates-project-management-page-js","40":"component---src-templates-property-listing-js","41":"component---src-templates-terms-page-js","42":"component---src-templates-testimonials-page-js","43":"component---src-templates-zhhans-about-us-page-zhhans-js","44":"component---src-templates-zhhans-asset-management-page-zhhans-js","45":"component---src-templates-zhhans-careers-page-zhhans-js","46":"component---src-templates-zhhans-contact-page-zhhans-js","47":"component---src-templates-zhhans-custom-homes-page-zhhans-js","48":"component---src-templates-zhhans-index-page-zhhans-js","49":"component---src-templates-zhhans-news-page-zhhans-js","50":"component---src-templates-zhhans-privacy-page-zhhans-js","51":"component---src-templates-zhhans-project-management-page-zhhans-js","52":"component---src-templates-zhhans-property-listing-zhhans-js","53":"component---src-templates-zhhans-terms-page-zhhans-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"32e7eb7a89dcf481db7b","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
